import React from 'react';
import { View } from 'react-native';
import { Banner, DefaultScreenContainer, Text } from '~/components';
import InsuranceQuoteCard from '~/scenes/MarisaAuto/Contract/components/QuoteResult/components/InsuranceQuoteCard';
import type { MarisaAutoStepsProps } from '../..';
import useMarisaAutoForm from '~/stores/marisaAutoForm';

const QuoteResult = ({ onContinue }: MarisaAutoStepsProps) => {
  const insuranceQuotes = useMarisaAutoForm((state) => state.insuranceQuotes);

  return (
    <DefaultScreenContainer className="bg-white h-[100%] align-top">
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="marisa-auto" />

        <View className="flex-1 mt-8 xl:mt-0 px-6 xl:px-0 xl:ml-24">
          <Text className="text-xl mb-4 text-gray-600">
            Resultados da simulação
          </Text>

          <Text className="text-gray-400 text-sm mb-4">
            Organizamos tudo para você! Toque nas opções para navegar e
            encontrar o plano que melhor lhe atender.
          </Text>

          {insuranceQuotes.map((insuranceQuote, index) => (
            <InsuranceQuoteCard
              key={index}
              insuranceQuote={insuranceQuote}
              bestOffer={index === 0}
              onContinue={() => onContinue()}
            />
          ))}
          <Text className="text-[11px] flex-grow text-gray-400 mb-8">
            *Valor depende da opção de pagamento escolhida.
          </Text>
        </View>
      </View>
    </DefaultScreenContainer>
  );
};

export default QuoteResult;
